import React from "react";

const Webchat = ({ color }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="20px"
        height="20px"
        fill-rule="evenodd"
        clip-rule="evenodd"
        baseProfile="basic"
      >
        <path
          fill={color}
          fill-rule="evenodd"
          d="M12.999,8.445v19.111	c0,1.901,1.544,3.445,3.445,3.445h25.111c1.901,0,3.445-1.544,3.445-3.445V8.445c0-1.901-1.544-3.445-3.445-3.445H16.445	C14.543,4.999,12.999,6.543,12.999,8.445z"
          clip-rule="evenodd"
        />
        <path
          fill={color}
          d="M2.999,45.501V17.445c0-1.901,1.544-3.445,3.445-3.445h6.559	l21.997,16.996v5.56c0,1.901-1.544,3.445-3.445,3.445H12.121L5.571,46.55c-0.273,0.279-0.653,0.451-1.072,0.451	C3.673,47.001,2.999,46.327,2.999,45.501z"
        />
        <path
          fill={color}
          d="M12.999,27.555V13.999h18.556	c1.901,0,3.445,1.544,3.445,3.445v13.556H16.445C14.543,31.001,12.999,29.457,12.999,27.555z"
        />
      </svg>
    </div>
  );
};

export default Webchat;
